import { Components } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

type TabProps = Components<Omit<Theme, 'components'>>['MuiTab'];

const getMuiTab = (): TabProps => ({
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      padding: '12px 24px',
      minHeight: 24,
      lineHeight: theme.typography.button.lineHeight,
      fontSize: theme.typography.button.fontSize,
      fontWeight: theme.typography.button.fontWeight as number,
      minWidth: '150px ',
      maxWidth: '264px',
      transition: 'opacity 200ms ease',
      textTransform: 'none',
      '&.withBorder': {
        borderBottom: `1px green solid`,
      },
      '&.MuiTab-wrapped': {
        // updated the style for wrapped tabs to match the visual contract
        fontSize: '0.857rem',
        lineHeight: '1.5em',
      },
      '&.MuiTab-labelIcon': {
        // updated the styles for labelIcon tabs to match the visual contract
      },
      '& > .MuiTab-iconWrapper': {
        marginBottom: '2px',
      },
      // Selected tab style
      '&.Mui-selected': {
        fontWeight: 'bold',
        color: theme.palette.semantic.text.primary,
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.button.fontSize,
      },
      '&:hover': {
        color: theme.palette.semantic.text.primary,
        opacity: 1,
        backgroundColor: theme.palette.semantic.interactive.surface.hover,
      },
      '&:active': {
        backgroundColor: '#E1E5EA',
      },
      '@media (min-width: 992px)': {
        fontSize: theme.typography.button.fontSize,
      },
    }),
  },
  // textColorInherit: ({ theme }: { theme: Theme }) => ({
  //     color: theme.palette.semantic.text.body,
  //     opacity: 1,
  //     "&.Mui-selected": {
  //         color: theme.palette.semantic.text.primary,
  //         opacity: 1,
  //     },
  // }),
});
export default getMuiTab;
